import React, { useEffect, useState } from 'react'
import axiosInstance from '../../../hooks/axiosInstance'
import { toast } from 'react-toastify'
import Loader from '../../utilities/Loader/Loader'

const Details = ({userId}) => {
    const [userProfile, setUserProfile] = useState(null)
    const [loading, setLoading] = useState(true)

    const fetchUserProfile = () => {
        setLoading(true)
        axiosInstance.get(`/association/user/profile/${userId}`)
              .then(res => {
                setUserProfile(res.data.data.user)
              })
              .catch(err => {
                // toast.error('An error occured. Please, try again')
              })
              .finally(() => setLoading(false))
    }

    useEffect(() => {
        fetchUserProfile()
    }, [userId])

  return (
    <>
        {/* Profile image */}
        <div className="card">
            <div className="card-body p-3">
                <div className="text-center">
                    <div className="profile-user position-relative d-inline-block mx-auto  mb-2">
                        <img src="/assets/images/users/avatar-1.jpg" className="rounded-circle avatar-lg img-thumbnail user-profile-image" alt="user-profile-image" />
                    </div>
                    <h5 className="fs-16 mb-1">{userProfile?.last_name} {userProfile?.first_name} {userProfile?.middle_name}</h5>
                    <p className="text-muted mb-0">{userProfile?.email}</p>
                </div>
            </div>
        </div> 

        {/* Basic Info */}
        <div className="card">
            <div className="card-body">
                <h5 className="card-title mb-3">Basic Info</h5>
                <div className="table-responsive">
                    <table className="table table-borderless mb-0">
                        <tbody>
                            <tr>
                                <th className="ps-0 py-2" scope="row">Full Name :</th>
                                <td className="text-muted py-2 text-capitalize">{userProfile?.title}. {userProfile?.last_name} {userProfile?.first_name} {userProfile?.middle_name}</td>
                            </tr>
                            <tr>
                                <th className="ps-0 py-2" scope="row">Phone :</th>
                                <td className="text-muted py-2">{userProfile?.phone}</td>
                            </tr>
                            <tr>
                                <th className="ps-0 py-2" scope="row">E-mail :</th>
                                <td className="text-muted py-2">{userProfile?.email}</td>
                            </tr>
                            <tr>
                                <th className="ps-0 py-2" scope="row">Address :</th>
                                <td className="text-muted py-2">
                                    {userProfile?.address ? userProfile?.address : '-'},&nbsp;
                                    {userProfile?.city?.name},&nbsp;
                                    {userProfile?.state?.name},&nbsp;
                                    {userProfile?.country?.name}
                                </td>
                            </tr>
                            <tr>
                                <th className="ps-0 py-2" scope="row">Date of Birth</th>
                                <td className="text-muted py-2">{userProfile?.dob}</td>
                            </tr>
                            <tr>
                                <th className="ps-0 py-2" scope="row">Spouse Phone</th>
                                <td className="text-muted py-2">{userProfile?.spouse ? userProfile?.spouse.phone : '-'}</td>
                            </tr>
                            <tr>
                                <th className="ps-0 py-2" scope="row">Spouse D.O.B</th>
                                <td className="text-muted py-2">{userProfile?.spouse ? userProfile?.spouse.dob : '-'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        {/* Children Details */}
        <div className="card">
            <div className="card-body">
                <div className="d-flex align-items-center mb-4">
                    <div className="flex-grow-1">
                        <h5 className="card-title mb-0">Children</h5>
                    </div>
                </div>
                <div>
                    {userProfile?.children.length > 0 ?
                        userProfile?.children.map(child => (
                            <div className="d-flex align-items-center py-2" key={child.id}>
                                <div className="avatar-xs flex-shrink-0 me-3">
                                    <img src="/assets/images/users/avatar-3.jpg" alt="" className="img-fluid rounded-circle" />
                                </div>
                                <div className="flex-grow-1">
                                    <div>
                                        <h5 className="fs-14 mb-1">{child.name}</h5>
                                        <p className="fs-12 text-muted mb-0"><b><i className='bx bx-calendar'></i></b>&nbsp; {child.dob}</p>
                                    </div>
                                </div>
                                <div className="flex-shrink-0 ms-2">
                                    <button type="button" className="btn btn-sm btn-outline-success"><i className="ri-user-add-line align-middle"></i></button>
                                </div>
                            </div>
                        ))
                    :
                        <div className="noresult">
                            <div className="text-center">
                                <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c" style={{width:"75px",height:"75px"}}></lord-icon>
                                <h5 className="mt-2">No data</h5>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>

        {/* Next of Kin Details */}
        <div className="card">
            <div className="card-body">
                <h5 className="card-title mb-3">Next of Kin</h5>
                {userProfile?.next_of_kin.length > 0 ?
                    userProfile?.next_of_kin.map(nok => (
                        <div className="d-flex flex-wrap gap-2 fs-15" key={nok.id}>
                            <a className="badge bg-primary-subtle text-primary">{nok.phone}</a>
                        </div>
                    ))
                :
                    <div className="noresult">
                        <div className="text-center">
                            <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c" style={{width:"75px",height:"75px"}}></lord-icon>
                            <h5 className="mt-2">No data</h5>
                        </div>
                    </div> 
                }
            </div>
        </div>

        {/* work experience details */}
        <div className="card">
            <div className="card-body">
                <h5 className="card-title">Work Experience</h5>
                {userProfile?.work_experience.length > 0 ?
                    <>
                        <div className="swiper project-swiper mt-n4 swiper-initialized swiper-horizontal swiper-backface-hidden">
                            <div className="d-flex justify-content-end gap-2 mb-2">
                                <div className="slider-button-prev swiper-button-disabled" tabindex="-1" role="button" aria-label="Previous slide" aria-controls="swiper-wrapper-baa75f008349cbc4" aria-disabled="true">
                                    <div className="avatar-title fs-18 rounded px-1">
                                        <i className="ri-arrow-left-s-line"></i>
                                    </div>
                                </div>
                                <div className="slider-button-next" tabindex="0" role="button" aria-label="Next slide" aria-controls="swiper-wrapper-baa75f008349cbc4" aria-disabled="false">
                                    <div className="avatar-title fs-18 rounded px-1">
                                        <i className="ri-arrow-right-s-line"></i>
                                    </div>
                                </div>
                            </div>
                            <div className="swiper-wrapper" id="swiper-wrapper-baa75f008349cbc4" aria-live="polite">
                                {userProfile?.work_experience.map(work => (
                                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="1 / 5" style={{width: "316.333px", marginRight: "25px"}} key={work.id}>
                                        <div className="card profile-project-card shadow-none profile-project-success mb-0">
                                            <div className="card-body p-4">
                                                <div className="d-flex">
                                                    <div className="flex-grow-1 text-muted overflow-hidden">
                                                        <h5 className="fs-14 text-truncate mb-1">
                                                            <a href="#" className="text-body">{work.organization}</a>
                                                        </h5>
                                                        <p className="text-muted text-truncate mb-0"> Employment Date : <span className="fw-semibold text-body">{work.employment_date}</span></p>
                                                        {work.status == 'resigned' && <p className="text-muted text-truncate mb-0"> Leaving Date : <span className="fw-semibold text-body">{work.leaving_date}</span></p>}
                                                    </div>
                                                    <div className="flex-shrink-0 ms-2">
                                                        <div 
                                                            className={`badge ${work.status == 'active' ? 'bg-success-subtle text-success' :
                                                                work.status == 'resigned' ? 'bg-warning-subtle text-warning' : 'bg-danger-subtle text-danger'
                                                            } text-capitalize fs-10`}
                                                        > {work.status}</div>
                                                    </div>
                                                </div>
                                                {work.status == 'resigned' && <div className="mt-3">
                                                    <p className="text-muted text-truncate mb-0"> Reason : <span className="text-body">{work.reason} </span></p>
                                                </div>}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                        <span className="swiper-notification" aria-live="assertive" aria-atomic="true"></span></div>
                    </>
                :
                    <div className="noresult">
                        <div className="text-center">
                            <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c" style={{width:"75px",height:"75px"}}></lord-icon>
                            <h5 className="mt-2">No data</h5>
                        </div>
                    </div>
                }
            </div>
        </div>

        {/* Qualification details */}
        <div className="card">
            <div className="card-body">
                <div className="d-flex align-items-center mb-4">
                    <div className="flex-grow-1">
                        <h5 className="card-title mb-0">Qualification</h5>
                    </div>
                </div>
                {userProfile?.qualification.length > 0 ?
                    userProfile?.qualification.map(qual => (
                        <div className="d-flex align-items-center mb-4" key={qual.id}>
                            <div className="flex-shrink-0 avatar-sm">
                                <div className="avatar-title bg-light text-primary rounded-3 fs-18">
                                    <i className="bx bxs-graduation"></i>
                                </div>
                            </div>
                            <div className="flex-grow-1 ms-3">
                                <h6 className='mb-1 text-capitalize'>{qual.qualification} {qual.dicipline}</h6>
                                <p className="text-muted mb-0 text-capitalize">{qual.institution}</p>
                            </div>
                            <div>
                                <p>{qual.year}</p>
                            </div>
                        </div>
                    ))
                :
                    <div className="noresult">
                        <div className="text-center">
                            <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c" style={{width:"75px",height:"75px"}}></lord-icon>
                            <h5 className="mt-2">No data</h5>
                        </div>
                    </div>
                }
            </div>
        </div>

        {/* Guarantor details */}
        <div className="mt-3">
            <div className="d-flex align-items-center mb-2">
                <div className="flex-shrink-0 me-1">
                    <i className="ri-map-pin-user-line fs-24 align-middle text-success me-1"></i>
                </div>
                <div className="flex-grow-1">
                    <h5 className="fs-16 mb-0 fw-semibold">Guarantor</h5>
                </div>
            </div>

            {userProfile?.guarantor.length > 0 ?
                <div className="accordion collapsed accordion-border-box" id="genques-accordion">
                    {userProfile?.guarantor.map((gua, i) => (
                        <div className="accordion-item" key={gua.id}>
                            <h2 className="accordion-header" id="genques-headingOne">
                                <button className="accordion-button  text-capitalize" type="button" data-bs-toggle="collapse" data-bs-target="#genques-collapseOne" aria-expanded="false" aria-controls="genques-collapseOne">
                                    {gua.title} {gua.last_name} {gua.first_name} {gua.middle_name}
                                </button>
                            </h2>
                            <div id="genques-collapseOne" className={`accordion-collapse ${i == 0 ? '' : 'collapse'}`} aria-labelledby="genques-headingOne" data-bs-parent="#genques-accordion">
                                <div className="accordion-body">
                                    <div className="table-responsive">
                                        <table className="table table-borderless mb-0">
                                            <tbody>
                                                <tr>
                                                    <th className="ps-0 py-2" scope="row">Phone :</th>
                                                    <td className="text-muted py-2">{gua.phone ? gua.phone : '-'}</td>
                                                </tr>
                                                <tr>
                                                    <th className="ps-0 py-2" scope="row">E-mail :</th>
                                                    <td className="text-muted py-2">{gua.email ? gua.email : '-'}</td>
                                                </tr>
                                                <tr>
                                                    <th className="ps-0 py-2" scope="row">Address :</th>
                                                    <td className="text-muted py-2">{gua.address ? gua.address : '-'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th className="ps-0 py-2" scope="row">Organization</th>
                                                    <td className="text-muted py-2">{gua.organization_name ? gua.organization_name : '-'}</td>
                                                </tr>
                                                <tr>
                                                    <th className="ps-0 py-2" scope="row">Office Address</th>
                                                    <td className="text-muted py-2">{gua.office_address ? gua.office_address : '-'}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            :
                <div className="noresult">
                    <div className="text-center">
                        <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c" style={{width:"75px",height:"75px"}}></lord-icon>
                        <h5 className="mt-2">No data</h5>
                    </div>
                </div>
            }
        </div>

        {loading && <Loader />}
    </>
  )
}

export default Details
